import { render } from "./CallBlock.vue?vue&type=template&id=56ec2082&scoped=true"
import script from "./CallBlock.vue?vue&type=script&lang=js"
export * from "./CallBlock.vue?vue&type=script&lang=js"

import "./CallBlock.vue?vue&type=style&index=0&id=56ec2082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ec2082"]])

export default __exports__